import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SoundService {
  private readonly success = new Audio('sounds/success.mp3');
  private readonly error = new Audio('sounds/error.mp3');

  playSuccess(): void { this.play(this.success); }
  playError(): void { this.play(this.error); }

  private play(audio: HTMLAudioElement): void {
    audio.currentTime = 0;
    audio.volume = 0.08;
    audio.play().catch(() => { /* autoplay blocked or file unavailable */ });
  }
}
